function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHamburgerMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.199,
    height: 11.25,
    viewBox: "0 0 13.199 11.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Hamburger Menu"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 1",
    style: {
      stroke: "#14a4c2",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M0 0h12.199",
    transform: "translate(.5 .5)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 496",
    d: "M0 0h12.2",
    transform: "translate(.5 5.625)",
    style: {
      stroke: "#ffa539",
      fill: "none",
      strokeLinecap: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 3",
    transform: "translate(.5 10.75)",
    style: {
      stroke: "#14a4c2",
      fill: "none",
      strokeLinecap: "round"
    },
    d: "M0 0h12.199"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHamburgerMenu);
export default __webpack_public_path__ + "static/media/hamburgerMenu.a34dd16a9d1993daeb31c0f4391f3268.svg";
export { ForwardRef as ReactComponent };